/* Product card photos: load the next photo before it's needed, so swiping or tapping the arrows never shows an empty
   gray frame (Amanda, Oct 29, 2026). Photo 1 loads as before. When a card comes near the screen, its photo 2 starts
   loading in the background; the rest load as soon as a shopper hovers, touches or tabs into that card's photos. */
(function () {
  function eager(img) { if (img && img.loading === "lazy") img.loading = "eager"; }
  function warm(card, all) {
    var imgs = card.querySelectorAll(".swiper-slide img");
    for (var i = 1; i < imgs.length; i++) { if (!all && i > 1) break; eager(imgs[i]); }
  }
  var io = "IntersectionObserver" in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { warm(e.target, false); io.unobserve(e.target); } });
  }, { rootMargin: "300px 0px" }) : null;
  function hook(card) {
    if (card.__bcWarm) return; card.__bcWarm = 1;
    var sp = card.querySelector(".swiper-parent"); if (!sp) return;
    ["pointerenter", "touchstart", "focusin"].forEach(function (t) { sp.addEventListener(t, function () { warm(card, true); }, { passive: true, once: true }); });
    if (io) io.observe(card); else warm(card, false);
  }
  function scan() { document.querySelectorAll(".product.bc-card").forEach(hook); }
  scan(); document.addEventListener("DOMContentLoaded", scan);
  // Cards added later (Show more, Best Sellers row, bag add-ons) get the same treatment
  var t; if (window.MutationObserver) new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 200); }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();

/* Laptop hover (Amanda, Oct 29, 2026: "a hover over that shows the next photo"): pointing at a card shows its photo 2,
   moving away goes back to photo 1. Mouse only, so phones keep swiping. Arrows and style dots still work; once a
   shopper uses them, hover stops moving that card.
   Nov 2, 2026 (Amanda: with little space between photos "you can end up scrolling over several items that are scrolling
   while you are also actively scrolling the page. Maybe your cursor has to be hovering closer to the center"): photo 2
   shows only when the pointer rests in the middle of the photo (inner 50%) for a moment, and never while the page is
   scrolling. Not in "Add a little extra" (photo 1 only there). */
(function () {
  if (!window.matchMedia || !matchMedia("(hover: hover) and (pointer: fine)").matches) return;
  var lastScroll = 0;
  window.addEventListener("scroll", function () { lastScroll = Date.now(); }, { passive: true });
  window.addEventListener("wheel", function () { lastScroll = Date.now(); }, { passive: true });
  document.addEventListener("pointerover", function (e) {
    if (e.pointerType !== "mouse") return;
    var sp = e.target.closest && e.target.closest(".product.bc-card .swiper-parent"); if (!sp || sp.__bcHover) return;
    if (sp.closest(".bc-addons-rail")) return;
    var el = sp.querySelector(".swiper-container"), sw = el && el.swiper; if (!sw || sw.slides.length < 2) return;
    sp.__bcHover = 1;
    var touched = false, timer = 0, idx = function () { return sw.realIndex != null ? sw.realIndex : sw.activeIndex; };
    var go = function (i) { if (sw.params.loop && sw.slideToLoop) sw.slideToLoop(i, 250); else sw.slideTo(i, 250); };
    sp.addEventListener("click", function (ev) { if (ev.target.closest(".swiper-button-next, .swiper-button-prev, .swiper-pagination")) touched = true; }, true);
    var card = sp.closest(".product.bc-card"); if (card) card.addEventListener("click", function (ev) { if (ev.target.closest(".bc-dot, .bc-more")) touched = true; }, true);
    var check = function (ev) {
      if (touched || idx() !== 0) return;
      var r = sp.getBoundingClientRect(), fx = (ev.clientX - r.left) / r.width, fy = (ev.clientY - r.top) / r.height;
      var center = fx > 0.25 && fx < 0.75 && fy > 0.25 && fy < 0.75;
      clearTimeout(timer);
      if (center) timer = setTimeout(function () { if (Date.now() - lastScroll > 300 && !touched && idx() === 0) go(1); }, 150);
    };
    sp.addEventListener("mousemove", check);
    sp.addEventListener("mouseleave", function () { clearTimeout(timer); if (!touched && idx() === 1) go(0); });
    check(e);
  });
})();

/* Two-photo cards (Amanda, Nov 2, 2026: "showing only the second photo when hovering or swiping").
   - Laptop: the older hover that flipped through every photo by mouse position (assets/bc-card.js) is switched off by
     marking each card; hovering now only shows photo 2 (block above).
   - A picked style shows its own photo: cards hold two photos, so when the style's photo isn't one of them, photo 1
     changes to it (data-card-img on the style list, snippets/product-item.liquid).
   - "Add a little extra" row (Amanda, Nov 2, 2026: swiping "just swipes through the photos of the item... vs. moving all
     the items"): in that row a swipe moves the row. Later Nov 2 (Amanda: "can we stop the photos from jumping to their second
     photo... maybe those photos don't show the 2nd photo"): that row shows photo 1 only (no arrows, no hover). */
(function () {
  function mark() {
    document.querySelectorAll(".bc-card .swiper-container").forEach(function (sc) { sc.dataset.bcHover = "1"; });
    var waiting = false;
    document.querySelectorAll(".bc-addons-rail .swiper-container").forEach(function (sc) {
      if (sc.swiper) { var w = sc.swiper; w.allowTouchMove = false; w.allowSlideNext = false; w.allowSlidePrev = false; } else waiting = true;
    });
    return waiting;
  }
  var tries = 0;
  function run() { if (mark() && ++tries < 40) setTimeout(run, 150); }
  run(); document.addEventListener("DOMContentLoaded", run); window.addEventListener("load", run);
  var t; if (window.MutationObserver) new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { tries = 0; run(); }, 200); }).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener("change", function (e) {
    var sel = e.target.closest && e.target.closest(".bc-card .variant-select"); if (!sel) return;
    var o = sel.selectedOptions && sel.selectedOptions[0], card = sel.closest(".bc-card");
    if (!o || !o.value || !card) return;
    if (!o.dataset.cardImg) return;
    var slides = card.querySelectorAll(".swiper-slide");
    if (!card.closest(".bc-addons-rail")) for (var i = 0; i < slides.length; i++) if ((slides[i].dataset.variantIds || "").split(",").indexOf(o.value) !== -1) return;
    var firsts = card.querySelectorAll('.swiper-slide[data-swiper-slide-index="0"] img');
    if (!firsts.length) { var one = card.querySelector(".swiper-slide img"); firsts = one ? [one] : []; }
    [].forEach.call(firsts, function (img) { img.srcset = o.dataset.cardSrcset || ""; img.src = o.dataset.cardImg; });
    var sc = card.querySelector(".swiper-container"), s = sc && sc.swiper;
    if (s) { var lock = !s.allowSlideNext; s.allowSlideNext = s.allowSlidePrev = true; if (s.params.loop && s.slideToLoop) s.slideToLoop(0, 0); else s.slideTo(0, 0); if (lock) s.allowSlideNext = s.allowSlidePrev = false; }
  });
})();
